export const TYRES_OPF_DASHBOARD = 'dashboard';
export const TYRES_OPF_MOVEMENT = 'movements';
export const TYRES_OPF_DETAIL = 'detail';

export const TYRES_OPF_TYRES_WAREHOUSE_CONTRACTS = 'tyres-warehouse-contracts';
export const TYRES_OPF_TYRES_DETAILS = 'tyres-details';
export const TYRES_OPF_CONTRACTS_DETAILS = 'contracts-details';
export const TYRES_OPF_WAREHOUSE_DETAILS = 'warehouse-details';